var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.06477 11.6412C0.852817 11.6882 0.670339 11.6352 0.517339 11.4823C0.36435 11.3293 0.311361 11.1468 0.358372 10.9348L0.916056 8.25794L3.74166 11.0835L1.06477 11.6412ZM3.74166 11.0835L0.916056 8.25794L8.39554 0.77846C8.62545 0.548549 8.91006 0.433594 9.24937 0.433594C9.58868 0.433594 9.87329 0.548549 10.1032 0.77846L11.2211 1.89639C11.451 2.1263 11.566 2.41092 11.566 2.75023C11.566 3.08954 11.451 3.37415 11.2211 3.60406L3.74166 11.0835ZM9.10834 1.48101L2.29167 8.29126L3.70834 9.70792L10.5186 2.89126C10.5571 2.85279 10.5763 2.80472 10.5763 2.74703C10.5763 2.68933 10.5571 2.64124 10.5186 2.60278L9.39682 1.48101C9.35835 1.44254 9.31027 1.42331 9.25257 1.42331C9.19488 1.42331 9.1468 1.44254 9.10834 1.48101Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/pen-icon.ca48f18fe2a3881162e3ab19ef15928a.svg";
export { ForwardRef as ReactComponent };